import { RouteFunctionParams, TileRoleRoute } from '@/types'
import { faBookOpen, faStore } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { ArgomentoProblema } from '@/routes/admin/tickets/pages/ArgomentoProblema'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { defer, LoaderFunction } from 'react-router-typesafe'

export const argomentoProblemaLoader = (async ({ request, params }: RouteFunctionParams) => {
  const apps = useQsAdminApiManager.getState().service.qs_supporto_applicazione().query()
  const platforms = useQsAdminApiManager.getState().service.piattaforma_ticket().query()
  return defer({
    apps,
    platforms,
  })
}) satisfies LoaderFunction

export const ArgomentoProblemaRoute: TileRoleRoute = {
  path: 'problemsubject',
  text: 'Argomento Problema',
  faIcon: faBookOpen,
  element: <ArgomentoProblema />,
  loader: argomentoProblemaLoader,
  handle: {
    crumb: () => ({
      label: 'Argomento Problema',
      icon: faStore,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
